import { SettingsIcon } from "frontend/icons/settings-icon";
import { ThreeDots } from "frontend/icons/three-dots";
import { Floater } from "frontend/ui-components/floaters/floater";
import React, { useRef, useState } from "react";
import { getPathPrefix } from "utils/getPathPrefix";
import styles from "./integrations-tasks-item.module.css";

type IntegrationsTasksItemProps = {
  name: string;
  isSelected: boolean;
  onSettingsClicked: () => void;
};

export const IntegrationsTasksItem = ({ name, isSelected, onSettingsClicked }: IntegrationsTasksItemProps) => {
  const integrationOptionsbutton = useRef(null);
  const [integratingSettingsClicked, setIntegratingSettingsClicked] = useState(false);

  return (
    <div className={styles.container}>
      <span className={styles.text}>{name}</span>

      <div className={styles.iconContainer}>
        {isSelected && <img src={getPathPrefix("/images/feature-check-i.svg")} />}
        <ThreeDots
          className={styles.icon}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIntegratingSettingsClicked(true);
          }}
          ref={integrationOptionsbutton}
        />
      </div>

      {integratingSettingsClicked && (
        <Floater
          relativeTo={integrationOptionsbutton}
          boundary="none"
          margin={-10}
          extraStyle={{
            zIndex: 500,
          }}
          alignment="start"
          side="bottom"
        >
          <div className={styles.floaterContainer}>
            <div
              className={styles.floaterContent}
              onClick={() => {
                setIntegratingSettingsClicked(false);
                onSettingsClicked();
              }}
            >
              <SettingsIcon className={styles.settingsIcon} />
              Settings
            </div>
          </div>
        </Floater>
      )}
    </div>
  );
};
